import React, {useEffect} from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import Home from "./pages/Home";
import Tables from "./pages/Tables";
import Billing from "./pages/Billing";
import Rtl from "./pages/Rtl";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import Login from "./pages/auth/Login";
import PrivateRoute from "./PrivateRoute";
import AdminRoute from "./AdminRoute";
import UserManagement from "./pages/UserManagement";
import SaveUser from "./pages/UserManagement/SaveUser";
// import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import 'react-toastify/dist/ReactToastify.css';
import Campaign from "./pages/Campaign";
import CampaignForm from "./pages/Campaign/form";
import { CampaignDetail } from "./pages/Campaign/detail";
import InterviewForm from "./pages/Interview/form";
import { InterviewDetail } from "./pages/Interview/details";
import Interview from "./pages/Interview";
import Activate from "./pages/auth/Activate";
import Reset from "./pages/auth/Reset";
import Profile from "./pages/UserManagement/profile";
import PageNotFound from "./pages/404";
import Dashboard from "./pages/Dashboard";
import UnderConstruction from "./pages/UnderConstruction";
import NoAccess from "./pages/NoAccess";
// import { useTranslation } from 'react-i18next';

function App() {
  useEffect(() => {
    const handleGlobalError = (event) => {
      console.error('Global error caught:', event.error);
      if (process.env.REACT_APP_ENV !== 'development') {
        window.location.href="/login";
      }
    };

    window.addEventListener('error', handleGlobalError);
    window.addEventListener('unhandledrejection', handleGlobalError);

    return () => {
      window.removeEventListener('error', handleGlobalError);
      window.removeEventListener('unhandledrejection', handleGlobalError);
    };
  }, []);

  return (
    <div className="App">
        <Routes>
        <Route path="/under-construction" element={<UnderConstruction />} />
          <Route path="/login" element={<Login />} />
          <Route path="/activate" element={<Activate />} />
          <Route path="/reset-password" element={<Reset />} />
          <Route path="/" element={<PrivateRoute component={Main} />}>
            <Route path="/dashboard" element={<PrivateRoute component={Dashboard}/>} />
            {/* <Route path="/sign-in" element={<PrivateRoute component={SignIn}/>} />
            <Route path="/profile" element={<PrivateRoute component={Profile}/>} />
            <Route path="/sign-up" element={<PrivateRoute component={SignUp}/>} />
            <Route path="/tables" element={<PrivateRoute component={Tables}/>} />
            <Route path="/billing" element={<PrivateRoute component={Billing}/>} />
            <Route path="/rtl" element={<PrivateRoute component={Rtl}/>} />
            <Route path="/profile" element={<PrivateRoute component={Profile}/>} />
            <Route path="/profile" element={<PrivateRoute component={Profile}/>} /> */}
            
            {/* User Management */}
            <Route path="/user-management" element={<AdminRoute component={UserManagement}/>} />
            <Route path="/user-management/add-user" element={<AdminRoute component={SaveUser}/>} />
            <Route path="/user-management/edit/:uuid" element={<AdminRoute component={SaveUser}/>} />
            <Route path="/profile/:uuid" element={<PrivateRoute component={Profile}/>} />

            {/* Campaign */}
            <Route path="/location" element={<PrivateRoute component={Campaign}/>} />
            <Route path="/location/create" element={<PrivateRoute component={CampaignForm}/>} />
            <Route path="/location/detail/:uuid" element={<PrivateRoute component={CampaignDetail}/>} />
            <Route path="/location/edit/:uuid" element={<PrivateRoute component={CampaignForm}/>} />

            {/* Interview */}
            <Route path="/interview" element={<PrivateRoute component={Interview}/>} />
            <Route path="/location/:campaignUUID/interview/create" element={<PrivateRoute component={InterviewForm}/>} />
            <Route path="/location/:campaignUUID/interview/edit/:uuid" element={<PrivateRoute component={InterviewForm}/>} />
            <Route path="/location/:campaignUUID/interview/detail/:uuid" element={<PrivateRoute component={InterviewDetail}/>} />


            {/* <Redirect from="*" to="/login" /> */}
          </Route>
          <Route path="/no-access" element={<NoAccess />} />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
        <ToastContainer />
      {/* <Switch>
        <Route path="/login" exact component={Login} />
        <Route path="/sign-up" exact component={SignUp} />
        <Route path="/sign-in" exact component={SignIn} />
        
        <Main>
          <Route exact path="/dashboard" component={Home} />
          <Route exact path="/tables" component={Tables} />
          <Route exact path="/billing" component={Billing} />
          <Route exact path="/rtl" component={Rtl} />
          <Route exact path="/profile" component={Profile} />
          
        </Main>
      </Switch> */}
    </div>
  );
}

export default App;
